export const BREAKPOINTS = {
    SIDEBAR: 1024,
} as const;
